import { createMemoryHistory } from 'history';

// History object used for routing in the LaunchBar
export const centerHistory = createMemoryHistory();
